export const CREATE_PLAN_ACTION = '[Plan Action] Create Plan';
export const CONFIRMED_CREATE_PLAN_ACTION = '[Plan Action] Confirmed Create Plan';
export const CREATE_PLAN_ERROR_ACTION='[Plan Action] Create Plan Error';
export const GET_PLANS = '[Plan Action] Get Plans';
export const CONFIRMED_GET_PLANS = '[Plan Action] Confirmed Get Plans';
export const LOADING_PLANS = '[Plan Action] Loading for Plans';
export const EDIT_PLAN_ACTION = '[Plan Action] Edit Plan';
export const CONFIRMED_EDIT_PLAN_ACTION = '[Plan Action] Confirmed Edit Plan';
export const DELETE_PLAN_ACTION = '[Plan Action] Delete Plan';
export const CONFIRMED_DELETE_PLAN_ACTION = '[Plan Action] Confirmed Delete Plan';
export const PLAN_ERROR_ACTION = '[Plan Action] Error';
export const CLEAR_PLAN_ERROR = '[Plan Action] Clear Error';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';



